
const initialState = {};

export default function Caller(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
